import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container page-frame" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row page-tab-row justify-content-md-end" }
const _hoisted_4 = { class: "col col-md-2 form-check form-check-inline radio-col" }
const _hoisted_5 = ["id", "value"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "col col-md-2 form-check form-check-inline radio-col" }
const _hoisted_8 = ["id", "value"]
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col table-content-wrap mb-2" }
const _hoisted_12 = { class: "row mb-2 justify-content-between" }
const _hoisted_13 = { class: "col-sm col-md-6 search-text-wrap" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col diff-table container" }
const _hoisted_17 = {
  key: 1,
  class: "row"
}
const _hoisted_18 = { class: "col container diff-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_PostingRecordDiffRow = _resolveComponent("PostingRecordDiffRow")!
  const _component_DailyDiffRow = _resolveComponent("DailyDiffRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumbs, {
      here: '配布記録一覧',
      ancestries: _ctx.ancestries
    }, null, 8, ["ancestries"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "col h2",
        style: _normalizeStyle({ fontSize: _ctx.FontSizes.large1})
      }, _toDisplayString(_ctx.staff.userName) + "さんの配布記録一覧", 5)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          class: "form-check-input",
          id: _ctx.tableTabOptions.BY_POSTING_RECORD,
          value: _ctx.tableTabOptions.BY_POSTING_RECORD,
          autocomplete: "off",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTabOption) = $event)),
          checked: ""
        }, null, 8, _hoisted_5), [
          [_vModelRadio, _ctx.selectedTabOption]
        ]),
        _createElementVNode("label", {
          class: "form-check-label",
          for: _ctx.tableTabOptions.BY_POSTING_RECORD
        }, "配布記録ごと", 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          class: "form-check-input",
          id: _ctx.tableTabOptions.BY_DATE,
          value: _ctx.tableTabOptions.BY_DATE,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTabOption) = $event)),
          autocomplete: "off"
        }, null, 8, _hoisted_8), [
          [_vModelRadio, _ctx.selectedTabOption]
        ]),
        _createElementVNode("label", {
          class: "form-check-label",
          for: _ctx.tableTabOptions.BY_DATE
        }, "日ごと", 8, _hoisted_9)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_ctx.selectedTabOption === _ctx.tableTabOptions.BY_POSTING_RECORD)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "検索",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchText) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.searchText]
                  ]),
                  _createElementVNode("div", {
                    class: "clear-button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickClearSearch && _ctx.onClickClearSearch(...args)))
                  })
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "col-sm col-md-2 diff-state-select",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.monthSelectedInt) = $event)),
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthList, (month, id) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: id,
                      value: month.monthInt
                    }, _toDisplayString(month.monthString), 9, _hoisted_14))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.monthSelectedInt]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "col-sm col-md-3 diff-state-select",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedDiffState) = $event))
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("option", { value: "all" }, "すべて", -1),
                  _createElementVNode("option", { value: "added" }, "追加", -1),
                  _createElementVNode("option", { value: "changed" }, "変更", -1),
                  _createElementVNode("option", { value: "deleted" }, "削除", -1)
                ]))], 512), [
                  [_vModelSelect, _ctx.selectedDiffState]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: "row header-row",
                    style: _normalizeStyle({ fontSize: _ctx.FontSizes.small1})
                  }, [...(_cache[8] || (_cache[8] = [
                    _createStaticVNode("<div class=\"col-1\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>配布日</span></div><div class=\"col-1\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>商品ID</span></div><div class=\"col-3\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>商品名</span></div><div class=\"col-1\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>配布地区</span></div><div class=\"col-2\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>配布エリア</span></div><div class=\"col-1\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>配布数合計</span></div><div class=\"col-1\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>配布単価</span></div><div class=\"col-1\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>委託費合計</span></div><div class=\"col-1\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>変更内容</span></div>", 9)
                  ]))], 4),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedDiffRecords, (recordDiff) => {
                    return (_openBlock(), _createBlock(_component_PostingRecordDiffRow, {
                      "record-diff": recordDiff,
                      key: recordDiff.vForKey
                    }, null, 8, ["record-diff"]))
                  }), 128))
                ])
              ])
            ], 64))
          : (_ctx.selectedTabOption === _ctx.tableTabOptions.BY_DATE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", {
                    class: "row header-row",
                    style: _normalizeStyle({ fontSize: _ctx.FontSizes.small1})
                  }, [...(_cache[9] || (_cache[9] = [
                    _createStaticVNode("<div class=\"col-3\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>配布日</span></div><div class=\"col-3\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>委託費合計（変更前）</span></div><div class=\"col-3\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>委託費合計（変更後）</span></div><div class=\"col-3\" data-v-3d7d1882><span class=\"wrap-text\" data-v-3d7d1882>変更内容</span></div>", 4)
                  ]))], 4),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dailyDiffs, (dDiff) => {
                    return (_openBlock(), _createBlock(_component_DailyDiffRow, {
                      key: dDiff.vForKey,
                      "daily-diff": dDiff
                    }, null, 8, ["daily-diff"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}